interface IGetPromotionSubheaderParams {
  isAuctionEnabled: boolean;
  isPromotionPackageSelected: boolean;
  isMobile: boolean;
}

export function getPromotionSubheader(params: IGetPromotionSubheaderParams): string | null {
  const { isAuctionEnabled, isPromotionPackageSelected, isMobile } = params;

  if (isPromotionPackageSelected) {
    return null;
  }

  if (!isAuctionEnabled) {
    return 'Выберите тип продвижения';
  }

  if (isMobile) {
    return 'Выберите подходящую ставку';
  }

  return 'Выберите готовую ставку или сделайте свою';
}
